import { calcUrl } from "@/features/ui/helpers/fetcher-helpers";
import useYWR, { YWRKey } from "@/features/ui/hooks/use-ywr";
import useFetcher from "@/utils/use-fetcher";
import { LightLineSheetSet } from "@/features/line-sheet-sets/line-sheet-set.types";

export interface UpdateLineSheetSetMoqRequest {
  moq: number | null;
}

export interface UpdateLineSheetSetMoqResponse extends LightLineSheetSet {}

export interface UpdateLineSheetSetMoqParameter {
  agencyId: number;
  lineSheetSetId: number;
}

export const updateLineSheetSetMoqTemplateUrl =
  "/agencies/:agencyId/line-sheet-sets/:lineSheetSetId/moq";

export const updateLineSheetSetMoqKey: YWRKey<UpdateLineSheetSetMoqParameter> = {
  url: (parameter) => {
    return calcUrl(updateLineSheetSetMoqTemplateUrl, parameter);
  },
  method: "patch",
};

export default function useUpdateLineSheetSetMoq() {
  const fetcher = useFetcher<
    UpdateLineSheetSetMoqRequest,
    UpdateLineSheetSetMoqResponse
  >();
  return useYWR(updateLineSheetSetMoqKey, fetcher);
}
